<template>
  <a-select v-model:value="customerWord" style="width:230px" @change="changeSelect">
    <a-select-option :value="v.id" v-for=" v in wordList" :key="v.id">{{v.field_name}}</a-select-option>
  </a-select>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import {member_attach_info_config} from '@/api/member'
export default {
  name: "selectCustomerWord",
  props: { attach_field_id: String || Number },
  setup(props, { emit }) {
    const customerWord = ref();
    const changeSelect = (e) => {
      emit("update:value", e);
    };
    const wordList = ref([]);
    const initData = async () => {
      let result = await member_attach_info_config({limit:10000})
        .then((res) => res.data)
        .catch((error) => error);
        wordList.value=result.data.data
      console.log(wordList.value);
      customerWord.value=wordList.value[0].id || ''
    };
    onMounted(() => {
      initData();
      if (props.attach_field_id) {
        customerWord.value = props.attach_field_id;
      }
       emit("update:value", customerWord.value);
    });
    return {
      customerWord,
      changeSelect,
      wordList,
    };
  },
};
</script>